import { AfterViewInit, Directive, ElementRef, Injector, Input } from '@angular/core';

@Directive({ selector: '[datePickerInitialValue]', })
export class DatePickerInitialValueSetterDirective implements AfterViewInit {
    hostElement: ElementRef;
    @Input() ngModel;

    constructor(injector: Injector, private readonly _element: ElementRef) {
        this.hostElement = _element;
    }

    ngAfterViewInit(): void {
        if (this.ngModel) {
            setTimeout(() => {
                (this.hostElement.nativeElement as any).value = this.ngModel.toFormat('D');
            });
        }
    }
}
